import React from 'react';
import OriginalSource, {
  Props as OriginalSourceProps,
} from '../OriginalSource';

const OriginalDelivered: React.FC<OriginalSourceProps> = props => {
  return <OriginalSource {...props} withHeader />;
};

OriginalDelivered.displayName = 'OriginalDelivered';
export default OriginalDelivered;
